import { Auth } from "aws-amplify";
import { call, put } from "redux-saga/effects";

import { MiniMessageBox } from "../../../../MiniMessageBox";

interface SignUp {
  email: string;
  password: string;
  member: {
    id: number;
    external_member_id: string;
    person_code: string;
    first_name: string;
    last_name: string;
  };
  plan: {
    id: number;
    name: string;
    client_id: string;
    bin_number: string;
    processor_control_number: string;
    plan_type: string;
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* authnzCognitoSignUp(payload: SignUp): Generator<any, any, any> {
  const { email, password, member, plan } = payload;
  const userType = plan.plan_type === "discount_card" ? "discount_card" : "commercial";

  return yield Auth.signUp({
    username: email.trim().toLowerCase(),
    password: password,
    attributes: {
      "custom:member_id": String(member.id),
      name: `${member.first_name} ${member.last_name}`,
      email: email,
      "custom:user_type": userType,
    },
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* authnzUserSignUpWorker(action: any): Generator<any, any, any> {
  const { payload, navigate } = action;

  try {
    yield call(authnzCognitoSignUp, payload);
    yield put(MiniMessageBox.hideMiniBoxMessage());
    // change the redirect to login screen once mobile is built and approved.
    navigate(`/confirm?email=${encodeURIComponent(payload.email.toLowerCase())}`);
  } catch (error) {
    if (error instanceof Error) {
      yield put(MiniMessageBox.showMiniBoxMessage({ show: true, type: "error", message: error.message }));
    }
  }
}
